module.exports = __webpack_public_path__ + "static/media/medicine-min.901d9ec8.jpg";